export { ConvertibleCarIcon } from './car-shape-convertible'
